import React, { Component } from "react";
import ".././navbar.css";

class Left extends Component {
  state = {};

  handleChange = (e) => {
    let { currentTarget: input } = e;
    let { lang, genre, format } = this.props;
    if (input.id === "lang") {
      let cb = lang.find((vl) => vl.name === input.name);
      if (cb) cb.value = input.checked;
    }
    if (input.id === "genre") {
      let gb = genre.find((vl) => vl.name === input.name);
      if (gb) gb.value = input.checked;
    }
    if (input.id === "format") {
      let fm = format.find((vl) => vl.name === input.name);
      if (fm) fm.value = input.checked;
    }

    this.props.onSubmit(lang, genre, format);
  };

  render() {
    return (
      <div className="container bg-light ">
        <div className="row text-center ">
          <img src="https://i.ibb.co/Hry1kDH/17443322900502723126.jpg"></img>
        </div>
        <br />

        <form>
          <div className="dropbtn border text-default ">
            <i
              className="fa fa-chevron-down"
              data-toggle="collapse"
              data-target="#collapseOne"
              aria-expanded="false"
              aria-controls="collapseOne"
              style={{ fontSize: "18px", color: "gray" }}
            >
              {"  "}
              <span id="onhover">Select Languages</span>
            </i>
          </div>
          <div className="collapse multi-collapse" id="collapseOne">
            <div className="card card-body">
              {this.props.lang.map((vl) => (
                <div className="form-group">
                  <input
                    type="checkbox"
                    value={vl.value}
                    name={vl.name}
                    id="lang"
                    checked={vl.value}
                    onChange={this.handleChange}
                    className="form-check-input ml-1"
                  ></input>
                  <label htmlFor={vl.name} className="form-check-label ml-4">
                    {vl.name}
                  </label>
                  <br />
                </div>
              ))}
            </div>
          </div>
          <br />

          <div className="dropbtn border">
            <i
              className="fa fa-chevron-down"
              data-toggle="collapse"
              data-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
              style={{ fontSize: "18px", color: "gray" }}
            >
              {"  "}
              Format
            </i>
          </div>
          <div className="collapse multi-collapse" id="collapseTwo">
            <div className="card card-body">
              {this.props.format.map((vl) => (
                <div className="form-group">
                  <input
                    type="checkbox"
                    value={vl.value}
                    name={vl.name}
                    checked={vl.value}
                    id="format"
                    onChange={this.handleChange}
                    className="form-check-input ml-1"
                  ></input>
                  <label htmlFor={vl.name} className="form-check-label ml-4">
                    {vl.name}
                  </label>
                  <br />
                </div>
              ))}
            </div>
          </div>
          <br />

          <div className="dropbtn border">
            <i
              className="fa fa-chevron-down"
              data-toggle="collapse"
              data-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
              style={{ fontSize: "18px", color: "gray" }}
            >
              {" "}
              Genre
            </i>
          </div>
          <div className="collapse multi-collapse" id="collapseThree">
            <div className="card card-body">
              {this.props.genre.map((vl) => (
                <div className="form-group">
                  <input
                    type="checkbox"
                    value={vl.value}
                    name={vl.name}
                    id="genre"
                    checked={vl.value}
                    onChange={this.handleChange}
                    className="form-check-input ml-1"
                  ></input>
                  <label htmlFor={vl.name} className="form-check-label ml-4 ">
                    {vl.name}
                  </label>
                  <br />
                </div>
              ))}
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default Left;
